// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__OOm1m","card":"styles_card__ODfwm"};